import React from "react";
import BaseText, {
  type TextProps as BaseTextProps,
} from "@src/packages/ui/Text/Text";
import { twMerge } from "tailwind-merge";

type MedicalHistoryTextProps =
  | BaseTextProps<"display">
  | BaseTextProps<"title">
  | BaseTextProps<"body">
  | BaseTextProps<"caption">;

/** Medical History text uses the app's DM Sans family by default. */
export function Text(props: BaseTextProps<"display">): React.ReactElement;
export function Text(props: BaseTextProps<"title">): React.ReactElement;
export function Text(props: BaseTextProps<"body">): React.ReactElement;
export function Text(props: BaseTextProps<"caption">): React.ReactElement;
export function Text({ className, ...props }: MedicalHistoryTextProps) {
  return <BaseText {...props} className={twMerge(className, "font-dm-sans")} />;
}

export default Text;
